angular.module('Itao.IndicatorMap').directive('barChartYears', function (d3, mapConfig, $timeout) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  var sortedAccessor = function (d, i) {
    return i;
  };
  var combineData = function (layers, indicator, disabledDataLayers, selectedDistricts, disabledDistrictKeys, withoutArea, colors, years) {
    if (indicator == null) {
      return [];
    }

    var allDistricts = {};
    var data = [];

    years.forEach(function (year, index) {
      for (var districtUid in layers[year].districts) {
        var value = layers[year][districtUid] && layers[year][districtUid][indicator.uid] ? layers[year][districtUid][indicator.uid] : null;
        if (layers[year][districtUid] && disabledDistrictKeys.indexOf(layers[year].districts[districtUid].key) === -1) {
          var key = layers[year].districts[districtUid].key;
          if (!allDistricts[key]) {
            allDistricts[key] = {
              key: key,
              name: layers[year].districts[districtUid].name,
              hasNoGeoData: layers[year].districts[districtUid].hasNoGeoData,

              values: []
            };
          }

          var yearDisabled = disabledDataLayers.map(function (year) {
            return +year;
          }).indexOf(year) !== -1;

          if (!yearDisabled && value != null) {
            allDistricts[key].values.push({
              districtuid: districtUid,
              year: +year,
              value: value,
              color: layers[year].color,
              key: key,
              name: layers[year].districts[districtUid].name,
              unit: indicator.unit
            });
          }
        }
      }
    });

    for (var district in allDistricts) {
      data.push(allDistricts[district]);
    }
    return data;
  };

  var calculateMaxValue = function (data) {
    return d3.max(data.map(function (current) {
      return d3.max(current.values, accessor('value'));
    }));
  };

  var calculateMinValue = function (data) {
    return d3.min(data.map(function (current) {
      return d3.min(current.values, accessor('value'));
    }));
  };

  var barChartYears = function () {
    var indicator = {},
      years = [],
      withoutArea = false,
      districtLabelProperty = 'key',
      svgHeight = 200,
      areaColor = '#000',
      margin = {top: 40, right: 10, bottom: 40, left: 50},
      duration = 400,
      displayValues = false,
      focusIndex,
      decimals,
      maxAxisValue,
      tip;

    var chart = function (selection) {
      selection.each(function (data) {

        //calculate min and max values and check that 0 is included
        var minValue = calculateMinValue(data);
        var maxValue = calculateMaxValue(data);
        if (minValue > 0) {
          minValue = 0;
        }

        if (maxValue < 0) {
          maxValue = 0;
        }

        // max-axis-value
        if (maxAxisValue) {
          maxValue = maxAxisValue;
        } else if (mapConfig.axisMaxValue != null) {
          maxValue = mapConfig.axisMaxValue;
        }

        // decimals
        if (!decimals && decimals !== 0) {
          decimals = indicator.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
        }

        var axisFormatString = ',.' + (maxValue < 7 ? '1' : '0') + 'f';

        //calculate the space needed for the y-axis labels
        var labelDigits = Math.max((indicator.prefix + germanNumberFormat(axisFormatString)(Math.round(maxValue))).length, (indicator.prefix + germanNumberFormat(axisFormatString)(Math.round(minValue))).length);
        margin.left = 20 + 10 * labelDigits;

        var districtLabelDigits = 1;
        if (data.length > 0) {
          districtLabelDigits = d3.max(data.map(function (d) {
            return accessor(districtLabelProperty)(d).length;
          }));
        }

        margin.bottom = Math.min(svgHeight / 2, 15 + 7 * districtLabelDigits);

        var container = d3.select(this).datum([data]).classed('bar-chart-years', true);

        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, yearNumber, districtNumber) {
            var district = data[districtNumber], value;
            if (indicator.unit === '%') {
              value = indicator.prefix + germanNumberFormat(',.' + decimals + 'f')(d.value) + '%';
            } else {
              value = indicator.prefix + germanNumberFormat(',.' + decimals + 'f')(d.value);
            }
            return '<div class="d3-tip-border" style="border-color:' + d.color + ';"><b>' + district.name + ' (' + district.key + ')</b><br>' + d.year + ': <span class="tooltip-value">' + value + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for districts
        var x0 = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.3)
          .domain(data.map(accessor(districtLabelProperty)));

        // scale for each bar per district
        var x1 = d3.scale.ordinal()
          .domain(years)
          .rangeBands([0, x0.rangeBand()]);

        var xLine = d3.scale.linear()
          .domain([d3.min(years), d3.max(years)])
          .range([0, x0.rangeBand()]);

        // scale for bar values
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxValue])
          .nice();

        var xAxis = d3.svg.axis()
          .scale(x0)
          .orient('bottom');

        var tickCount = Math.min(svgHeight / 40, 10);

        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(tickCount)
          .tickFormat(function (d) {
            return indicator.prefix + germanNumberFormat(axisFormatString)(d);
          });

        var redLines = indicator.redLines ? indicator.redLines : mapConfig.redLines;

        g.call(d3.hyperion.addHorizontalGridLines(y, width, 0, tickCount, duration));

        gEnter.append('g')
          .attr('class', 'x axis');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('text-anchor', districtLabelDigits > 4 ? 'end' : 'middle')
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          })
          .attr('dx', districtLabelDigits > 4 ? '-.8em' : '')
          .attr('dy', '.15em')
          .attr('transform', districtLabelDigits > 4 ? 'rotate(-65)' : '')
          .attr('dominant-baseline', 'central');

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .transition().duration(duration)
          .call(yAxis);

        var area = d3.svg.area()
          .x(function (d, i) {
            return xLine(d.year);
          })
          .y0(y(0))
          .y1(function (d) {
            return y(Math.min(maxValue, d.value));
          });

        // only draw bars if years and an indicator are present
        if (angular.isArray(years) && years.length > 0 && angular.isObject(indicator) && indicator.hasOwnProperty('key')) {

          var unit = indicator.unit;

          svgEnter.append('text')
            .attr('class', 'axis-unit-label')
            .attr('text-anchor', 'end')
            .attr('transform', 'translate(' + (margin.left - 7) + ', 10)');

          svg.select('.axis-unit-label')
            .text(unit === '%' ? 'in %' : '');

          // create a feature per district
          var features = g.selectAll('.feature')
            .data(data, accessor('key'));

          features
            .enter().append('g')
            .classed('feature', true)
            .classed('visually-hidden', !withoutArea && years.length > 1)
            .attr('stroke', 'black');

          features
            .classed('visually-hidden', !withoutArea && years.length > 1)
            .attr('transform', function (d) {
              return 'translate(' + x0(d[districtLabelProperty]) + ')';
            })
            .attr('stroke-width', function (d) {
              return accessor('selected')(d) ? '2px' : '0px';
            })
            .attr('data-key', function (d) {
              return accessor('key')(d);
            });

          var featureAreas = g.selectAll('.featureArea')
            .data(data, accessor('key'));

          var $svg = jQuery(svg[0]);

          // since the mousemove is debounced we need to check if the mouse left the area in the meantime
          var mouseOverActive = false;

          /**
           * show features (bars) by key
           * @param element
           * @param key
           */
          var showFeaturesByKey = function (element, key) {
            jQuery(element).attr('class', 'featureArea visually-hidden');
            $svg.find('.feature[data-key="' + key + '"]').attr('class', 'feature');
          };

          /**
           * hide features (bars) by key
           * @param element
           * @param key
           */
          var hideFeaturesByKey = function (element, key) {
            jQuery(element).attr('class', 'featureArea');
            $svg.find('.feature[data-key="' + key + '"]').attr('class', 'feature visually-hidden');
          };

          /**
           * handle mouse-move event and show/hide bars
           * @param event
           */
          var mouseMoveFunction = function (event) {
            if (mouseOverActive) {
              $svg.find('.featureArea').each(function (index, element) {
                var key = jQuery(element).data('key');
                var clientRect = element.getBoundingClientRect();
                var x = clientRect.left;
                var width = clientRect.width;
                if (event.pageX > x && event.pageX < (x + width)) {
                  // show bars - hide area
                  showFeaturesByKey(element, key);
                } else {
                  // show area - hide bars
                  hideFeaturesByKey(element, key);
                }
              });
            } else {
              resetMouseMoveFunction();
            }
          };

          var resetMouseMoveFunction = function () {
            mouseOverActive = false;
            $svg.find('.featureArea').attr('class', 'featureArea');
            $svg.find('.feature').attr('class', 'feature visually-hidden');
          };

          if (!withoutArea && years.length > 1) {
            featureAreas
              .enter().append('path')
              .classed('featureArea', true)
              .attr('fill', areaColor)
              .attr('transform', function (d) {
                return 'translate(' + x0(d[districtLabelProperty]) + ')';
              })
              .attr('d', function (d) {
                return area(d.values);
              });

            featureAreas
              .transition().duration(duration)
              .attr('d', function (d) {
                return area(d.values);
              })
              .attr('transform', function (d) {
                return 'translate(' + x0(d[districtLabelProperty]) + ')';
              })
              .attr('data-key', function (d) {
                return accessor('key')(d);
              });
            // clear mouse events on repeated paints
            $svg.off('mouseenter');
            $svg.off('mousemove');
            $svg.off('mouseleave');

            $svg.mouseenter(function () {
              mouseOverActive = true;
            });

            $svg.mousemove(_.debounce(mouseMoveFunction, 50, {maxWait: 150}));

            $svg.mouseleave(function () {
              mouseOverActive = false;
              resetMouseMoveFunction();
            });
          } else {
            $svg.off('mouseenter');
            $svg.off('mousemove');
            $svg.off('mouseleave');
            featureAreas.remove();
          }
          features.exit().remove();
          featureAreas.exit().remove();

          var barXValue = compose(x1, accessor('year'));
          var bars = features.selectAll('rect')
            .data(accessor('values'), accessor('year'));

          // draw new bars
          bars
            .enter()
            .append('rect')
            .style('fill', accessor('color'))
            .attr('width', 0)
            .attr('x', barXValue)
            .attr('y', y(0))
            .attr('height', 0);

          // update all bars
          bars
            .transition().duration(duration)
            .style('fill', accessor('color'))
            .attr('class', function (d) {
              return 'bar-' + (d.year);
            })
            .attr('width', x1.rangeBand())
            .attr('x', barXValue)
            .attr('y', function (d) {
              return y(Math.min(maxValue, Math.max(0, accessor('value')(d))));
            })
            .attr('height', function (d) {
              return Math.abs(y(0) - y(Math.min(maxValue, accessor('value')(d))));
            });

          // add tooltips to bars
          bars.call(tip);
          bars.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          // remove unused bars
          bars.exit().transition().duration(duration)
            .attr('width', 0)
            .attr('y', y(0))
            .attr('height', function () {
              return height - y(0);
            })
            .remove();

          g.selectAll('line.highlightLine').remove();
          g.selectAll('line.highlightArea').remove();

          g.call(d3.hyperion.addHorizontalHighlightLines(redLines, y, width, duration));
          g.call(d3.hyperion.addHorizontalHighlightArea(redLines, y, x0, width, duration));

          var labels = features.selectAll('text')
            .data(accessor('values'), accessor('year'));

          if (displayValues) {
            labels.enter()
              .append('text')
              .attr('class', 'chart-value')
              .attr('writing-mode', 'tb')
              .attr('y', 0);

            // update labels
            labels
              .text(function (d) {
                return germanNumberFormat('.0f')(accessor('value')(d));
              })
              .attr('x', function (d, i) {
                return (x1.rangeBand() / 2) + (x1.rangeBand() * i);
              })
              .attr('y', function (d, i) {
                // var plus = i % 2 === 0 ? 0 : 14;
                return y(Math.max(0, accessor('value')(d))) - 8;
              })
              .attr('dx', '-4');
            // remove unused labels
            labels.exit()
              .remove();
          } else {
            labels
              .remove();
          }
        } else {
          // remove all bars if no indicators are active
          jQuery(svg[0]).off('mousemove');
          g.selectAll('rect').remove();
          g.selectAll('line').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Object} [newIndicator] set of new indicators
     * @returns {*}
     */
    chart.indicator = function (newIndicator) {
      if (!arguments.length) {
        return indicator;
      } else {
        indicator = newIndicator;
        return chart;
      }
    };

    /**
     * getter/setter for years
     * @param {int} [newYears] set of years
     * @returns {*}
     */
    chart.years = function (newYears) {
      if (!arguments.length) {
        return years;
      } else {
        years = newYears;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [districtLabelProperty] name of property to use for districtlabels
     * @returns {*}
     */
    chart.districtLabelProperty = function (newdistrictLabelProperty) {
      if (!arguments.length) {
        return districtLabelProperty;
      } else {
        districtLabelProperty = newdistrictLabelProperty;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [newWithoutArea] name of property to use for districtlabels
     * @returns {*}
     */
    chart.withoutArea = function (newWithoutArea) {
      if (!arguments.length) {
        return withoutArea;
      } else {
        withoutArea = newWithoutArea;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newFocusIndex] height of the diagram
     * @returns {*}
     */
    chart.focusYear = function (newFocusIndex) {
      if (!arguments.length) {
        return focusIndex;
      } else {
        focusIndex = newFocusIndex;
        return chart;
      }
    };

    /**
     * getter/setter for areaColor
     * @param {Function} [newAreaColor] new areaColor function
     * @returns {*}
     */
    chart.areaColor = function (newAreaColor) {
      if (!arguments.length) {
        return areaColor;
      } else {
        areaColor = newAreaColor;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    return element.closest('.grid-stack-item-content-barChartYears,.grid-stack-item-content-barChartYearsWithoutArea').height() - jQuery(element).find('chart-indicator-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'barChartYears.html',
    scope: {
      layers: '=',
      selectedDistricts: '=',
      disabledDataLayers: '=',
      disabledDistrictKeys: '=',
      selectedChartColorset: '=',
      decimalsOverride: '=',
      maxAxisValueOverride: '=',
      indicators: '=',
      mouseOverFeature: '=',
      dimensionX: '@',
      dimensionY: '@',
      withoutArea: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.disabledIndicators = scope.config.disabledIndicators || [];
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.withoutArea = scope.config.withoutArea || false;
      scope.config.displayValues = scope.config.displayValues || false;
      scope.yearsToHide = mapConfig.yearsToHide ? mapConfig.yearsToHide : [];

      var barChartYearsFunction = barChartYears();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (!Object.keys(scope.layers)[0] || !scope.layers[Object.keys(scope.layers)[0]] || Object.keys(scope.layers[Object.keys(scope.layers)[0]].districts).length === scope.disabledDistrictKeys.length || !scope.selectedChartColorset) {
          return null;
        }

        scope.withoutArea = scope.config.withoutArea ? '1' : false;

        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicators = scope.indicators.filter(function (indicator) {
          return indicator.hasShapeData;
        });

        var filteredIndicators = indicators.filter(function (indicator) {
          return scope.config.disabledIndicators.indexOf(indicator.key) === -1;
        });

        var years = Object.keys(scope.layers);
        var filteredYears = years
          .filter(function (year) {
            return scope.layers[year].indicators.indexOf(filteredIndicators[0].uid) !== -1;
          })
          .filter(function (year) {
            return scope.yearsToHide.indexOf(year) === -1;
          })
          .map(function (year) {
            return +year;
          });

        if (!filteredYears.length) {
          scope.disabledDataLayers = [];
        }

        var colors = scope.selectedChartColorset.colors.map(function (color) {
          return color.color;
        });
        var colorAt = 1;
        var areaColor = colors[0];
        var yearsToShow = [];


        /** overwrite first legend-entry with displayed years */
        var displayedYears = filteredYears.filter(function (year) {
          return scope.disabledDataLayers.indexOf('' + year) < 0;
        });

        var legend = undefined;
        var firstYear = displayedYears[0],
          lastYear = displayedYears[displayedYears.length - 1],
          fromYearLabel = firstYear,
          toYearLabel = lastYear,
          indicatorUid = filteredIndicators[0].uid;

        if (scope.layers[firstYear] && scope.layers[firstYear].legend && scope.layers[firstYear].legend[indicatorUid] && scope.layers[firstYear].legend[indicatorUid].chart.yearLabelOverride) {
          fromYearLabel = scope.layers[firstYear].legend[indicatorUid].chart.yearLabelOverride;
        }

        if (scope.layers[lastYear] && scope.layers[lastYear].legend && scope.layers[lastYear].legend[indicatorUid] && scope.layers[lastYear].legend[indicatorUid].chart.yearLabelOverride) {
          toYearLabel = scope.layers[lastYear].legend[indicatorUid].chart.yearLabelOverride;
          legend = scope.layers[lastYear].legend[indicatorUid].chart;
        }

        var filteredColors = [];
        if (legend && legend.scales) {
          legend.scales.forEach(function (scale, index) {
            if(scale.text){
              filteredColors.push(colors[index]);
            }
          });
        } else {
          filteredColors = colors;
        }

        /** bind color to year */
        filteredYears.forEach(function (year) {
          if (scope.disabledDataLayers.indexOf(year+'') < 0) {
            scope.layers[year].color = filteredColors[colorAt];
            yearsToShow.push(year);
          }
          colorAt++;
        });

        /** get chart-data to display */
        var data = combineData(scope.layers, filteredIndicators[0], scope.disabledDataLayers, scope.selectedDistricts, scope.disabledDistrictKeys, scope.withoutArea === '1', colors, filteredYears);

        /** call chart-functions */
        barChartYearsFunction
          .areaColor(areaColor)
          .indicator(filteredIndicators[0])
          .districtLabelProperty(scope.config.districtLabelProperty)
          .focusYear(scope.mouseOverFeature)
          .years(yearsToShow)
          .withoutArea(scope.withoutArea === '1')
          .displayValues(scope.config.displayValues)
          .decimals(scope.decimalsOverride)
          .maxAxisValue(scope.maxAxisValueOverride)
          .height(newHeight);

        d3.select(element.find('.widget-inner:first')[0])
          .data([data])
          .call(barChartYearsFunction);

        $timeout(function () {
          jQuery('.legend-item:first .color-set-colors .legend-scale-text').html(fromYearLabel + ' - ' + toYearLabel);
        }, 10);
      };

      jQuery(document).on("fullscreen", rerender);

      var layersWatcher = scope.$watch('layers', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var disabledDataLayersWatcher = scope.$watchCollection('disabledDataLayers', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var disabledIndicators = scope.$watchCollection('config.disabledIndicators', rerender);
      var districtLabelPropertyWatcher = scope.$watchCollection('config.districtLabelProperty', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var withoutAreaWatcher = scope.$watch('config.withoutArea', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);
      var selectedChartColorsetWatcher = scope.$watch('selectedChartColorset', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layersWatcher();
        indicatorWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        disabledIndicators();
        districtLabelPropertyWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();
        disabledDataLayersWatcher();
        disabledDistrictKeysWatcher();
        withoutAreaWatcher();
        displayValuesWatcher();
        selectedChartColorsetWatcher();

        // remove tooltip dom element
        if (angular.isDefined(barChartYearsFunction.tip())) {
          barChartYearsFunction.tip().destroy();
        }
      });
    }
  };
});
